import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Code } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const PythonScriptNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Python Script'}
        icon={Code}
        colorClass="from-indigo-500 to-indigo-700"
        bgClass="bg-gradient-to-br from-indigo-500 to-indigo-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
PythonScriptNode.displayName = 'PythonScriptNode';
export default PythonScriptNode;
